var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"photo",class:_vm.color},[_c('img',{attrs:{"src":require(("../assets/" + _vm.image))}}),_c('figcaption',[_c('h2',[_c('span',[_vm._v(_vm._s(_vm.text))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }